import type { RetentionMode } from '@sentinel/shared';
import { toast, useErrorMessage } from '@sentinel/web-core';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { consoleEndpoints } from '@/api/endpoints';
import { keys } from '@/api/keys';

/** The platform retention run: read it, switch it between preview and deletion. */
export function usePlatformRetention() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const errorMessage = useErrorMessage();
  const overview = useQuery({ queryKey: keys.retention, queryFn: consoleEndpoints.retention });
  const setMode = useMutation({
    mutationFn: (mode: RetentionMode) => consoleEndpoints.setRetentionMode(mode),
    onSuccess: (next) => {
      queryClient.setQueryData(keys.retention, next);
      const tone = next.mode === 'active' ? 'att' : 'ok';
      toast(tone, t(`console.settings.retention.switched.${next.mode}`));
    },
    onError: (error) => toast('att', errorMessage(error)),
  });
  return { overview, setMode };
}
